import Data from '../Data';

// Action Types

export const RequestJobs = 'canny/jobs/request_jobs';
export const JobsLoaded = 'canny/jobs/jobs_loaded';
export const JobsError = 'canny/jobs/jobs_error';

// Actions

function requestJobs() {
  return {
    timestamp: Date.now(),
    type: RequestJobs,
  };
}

function jobsLoaded(jobs) {
  return {
    jobs,
    timestamp: Date.now(),
    type: JobsLoaded,
  };
}

function jobsError(error) {
  return {
    error,
    timestamp: Date.now(),
    type: JobsError,
  };
}

// Action Creators

function fetchJobs() {
  return (dispatch, getState) => {
    const cookies = getState().cookies;
    return Data.fetch(
      {
        jobs: { query: Data.queries.jobs },
      },
      cookies,
      (error, data) => {
        if (error) {
          return dispatch(jobsError(error));
        } else {
          return dispatch(jobsLoaded(data.jobs));
        }
      },
    );
  };
}

export function loadJobs() {
  return (dispatch, getState) => {
    if (shouldFetchJobs(getState())) {
      dispatch(requestJobs());
      return dispatch(fetchJobs());
    }

    return Promise.resolve();
  };
}

export function reloadJobs() {
  return (dispatch, getState) => {
    return dispatch(fetchJobs());
  };
}

// Helpers

function shouldFetchJobs(state) {
  return !state.jobs;
}
